export function sortWebsitesByPosition(websites, positionMap) {
  return websites.sort((a, b) => {
    const posA = positionMap.get(a.rowData.id);
    const posB = positionMap.get(b.rowData.id);

    if (posA != null && posB != null) {
      return posA - posB;
    }

    if (posA != null) {
      return -1;
    }

    if (posB != null) {
      return 1;
    }
    return 0;
  });
}

export function buildSelectedPayload(sortedSelectedData, currentWebsiteId, selectedIds) {
  const selectedPayload = [];
  for (const item of sortedSelectedData) {

  if (selectedIds.has(item.rowData.id)) {
      selectedPayload.push(item);
    }
  }

  return selectedPayload.map((item, index) => ({
    websiteSourceId: currentWebsiteId,
    websiteTargetId: item.rowData.id,
    position: index + 1,
    xDefault: item.xDefault || false,
    includedPages: Object.entries(item.includePages || {})
      .filter(([, isIncluded]) => Boolean(isIncluded))
      .map(([pageName]) => pageName)
  }));
}

export function buildRemovedPayload(selected, seoLinkedWebsites) {
  const selectedIds = selected.map(s => s.websiteTargetId);
  const positionToTargetMap = new Map(
    selected.map(website => {
      const positionKey = `${website.websiteSourceId}-${website.position}`;
      return [positionKey, website.websiteTargetId]
    })
  );

  const removed = [];

  for (const item of seoLinkedWebsites) {
    const row = item.rowData;

    const isUnlinked = !selectedIds.includes(row.websiteTargetId);
    const positionKey = `${row.websiteSourceId}-${row.position}`;
    const newTargetAtPosition = positionToTargetMap.get(positionKey);
    const isPositionChanged = newTargetAtPosition && newTargetAtPosition !== row.websiteTargetId;

    if (isUnlinked || isPositionChanged) {
      removed.push({
        websiteSourceId: row.websiteSourceId,
        websiteTargetId: row.websiteTargetId,
        position: row.position,
      });
    }
  }

  return removed;
}

export function moveWebsiteInList(websites, websiteId, currentWebsiteId, direction, shiftKeyPressed) {
  const hidden = websites.find(w => w.rowData.id === currentWebsiteId) || null;
  const visible = websites.filter(w => w.rowData.id !== currentWebsiteId);
  const index = visible.findIndex(w => w.rowData.id === websiteId);

  if (index === -1) {
    return websites;
  }
  if (direction === 'up' && index === 0) {
    return websites;
  }
  if (direction === 'down' && index === visible.length - 1) {
    return websites;
  }

  const [moved] = visible.splice(index, 1);

  if (shiftKeyPressed) {
    direction === 'up' ? visible.unshift(moved) : visible.push(moved);
  } else {
    const newIndex = direction === 'up' ? index - 1 : index + 1;
    visible.splice(newIndex, 0, moved);
  }

  return hidden ? [hidden, ...visible] : visible;
}

export function getErrorMessage(error) {
  const errorData = error?.data?.error;
  return errorData ? (Array.isArray(errorData) ? errorData[0] : errorData) : 'Unexpected error occurred';
}

export function prepareSeoLinkedWebsiteDataToReorder(data) {
  return data.map(item => ({
    rowData: {
      id: item.id,
      websiteSourceName: item.websiteSource.name,
      websiteTargetName: item.websiteTarget.name,
      websiteSourceId: item.websiteSourceId,
      websiteTargetId: item.websiteTargetId,
      position: item.position,
      xDefault: item.xDefault
    }
  }));
}